import React, { Component } from "react"
import PropTypes from "prop-types"
import posed from "react-pose"

const PosedLi = posed.li({
  flip: {
    transition: { type: "spring", damping: 500, stiffness: 500, mass: 1, velocity: 100 },
  },
})

export default class DrilldownItem extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
  }

  static defaultProps = {
    children: "",
    className: "",
  }

  render() {
    return (
      <PosedLi {...this.props} className={"common-drilldown-item " + this.props.className}>
        {this.props.children}
      </PosedLi>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/common/DrilldownItem.js